import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "how-to-play" }
const _hoisted_2 = { class: "sections" }
const _hoisted_3 = { class: "instruction-section" }
const _hoisted_4 = { class: "section-content image-first" }
const _hoisted_5 = { class: "image-content" }
const _hoisted_6 = {
  key: 0,
  class: "image-placeholder",
  "aria-hidden": "true"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "text-content" }
const _hoisted_9 = { class: "instruction-section" }
const _hoisted_10 = { class: "section-content image-last" }
const _hoisted_11 = { class: "text-content" }
const _hoisted_12 = { class: "image-content" }
const _hoisted_13 = {
  key: 0,
  class: "image-placeholder",
  "aria-hidden": "true"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "instruction-section" }
const _hoisted_16 = { class: "section-content image-first" }
const _hoisted_17 = { class: "image-content" }
const _hoisted_18 = {
  key: 0,
  class: "image-placeholder",
  "aria-hidden": "true"
}
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "text-content" }
const _hoisted_21 = { class: "instruction-section" }
const _hoisted_22 = { class: "section-content image-last" }
const _hoisted_23 = { class: "text-content" }
const _hoisted_24 = { class: "image-content" }
const _hoisted_25 = {
  key: 0,
  class: "image-placeholder",
  "aria-hidden": "true"
}
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "instruction-section" }
const _hoisted_28 = { class: "section-content image-first" }
const _hoisted_29 = { class: "image-content" }
const _hoisted_30 = {
  key: 0,
  class: "image-placeholder",
  "aria-hidden": "true"
}
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "text-content" }
const _hoisted_33 = {
  key: 0,
  class: "book-bet-note"
}
const _hoisted_34 = { class: "instruction-section" }
const _hoisted_35 = { class: "section-content image-last" }
const _hoisted_36 = { class: "text-content" }
const _hoisted_37 = { class: "image-content" }
const _hoisted_38 = {
  key: 0,
  class: "image-placeholder",
  "aria-hidden": "true"
}
const _hoisted_39 = ["src"]

import { computed } from 'vue'

import SectionHeader from '@/components/base/SectionHeader.vue'
import { useTheme } from '@/composables/useTheme'
import { useGameStore } from '@/stores/game'
import { useIntegrationMode } from '@/composables/useIntegrationMode'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'HowToPlayView'
},
  __name: 'HowToPlayView',
  setup(__props) {



const { getAssetPath } = useTheme()
const gameStore = useGameStore()
const { isLite } = useIntegrationMode()

const showBookABetNote = computed(() => {
  const modules = gameStore.getBetSettings?.enabled_modules
  return Array.isArray(modules) && modules.includes('book_a_bet')
})

const howToPlayStep1 = computed(() => getAssetPath('howToPlay', 'step1') || '/img/images/how-to-play/1-select-game.png')
const howToPlayStep2 = computed(() => getAssetPath('howToPlay', 'step2') || '/img/images/how-to-play/2-select-draws.png')
const howToPlayStep3 = computed(() => getAssetPath('howToPlay', 'step3') || '/img/images/how-to-play/3-select-market.png')
const howToPlayStep4 = computed(() => getAssetPath('howToPlay', 'step4') || '/img/images/how-to-play/4-confirm-your-entries.png')
const howToPlayStep5 = computed(() => getAssetPath('howToPlay', 'step5') || '/img/images/how-to-play/5-your-betslip.png')
const howToPlayStep6 = computed(() => getAssetPath('howToPlay', 'step6') || '/img/images/how-to-play/6-wager-details.png')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SectionHeader, {
      title: _ctx.$t('howToPlay.title'),
      subtitle: _ctx.$t('howToPlay.subtitle'),
      variant: "complex"
    }, null, 8, ["title", "subtitle"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_unref(isLite))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: howToPlayStep1.value,
                  alt: "Select Your Game"
                }, null, 8, _hoisted_7))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('howToPlay.step1Title')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step1Text1')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step1Text2')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step1Text3')), 1)
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('howToPlay.step2Title')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step2Text1')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step2Text2')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step2Text3')), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_unref(isLite))
              ? (_openBlock(), _createElementBlock("div", _hoisted_13))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: howToPlayStep2.value,
                  alt: "Select Your Draws"
                }, null, 8, _hoisted_14))
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            (_unref(isLite))
              ? (_openBlock(), _createElementBlock("div", _hoisted_18))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: howToPlayStep3.value,
                  alt: "Select Your Market"
                }, null, 8, _hoisted_19))
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('howToPlay.step3Title')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step3Text1')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step3Text2')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step3Text3')), 1)
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('howToPlay.step4Title')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step4Text1')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step4Text2')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step4Text3')), 1)
          ]),
          _createElementVNode("div", _hoisted_24, [
            (_unref(isLite))
              ? (_openBlock(), _createElementBlock("div", _hoisted_25))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: howToPlayStep4.value,
                  alt: "Confirm Your Entries"
                }, null, 8, _hoisted_26))
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            (_unref(isLite))
              ? (_openBlock(), _createElementBlock("div", _hoisted_30))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: howToPlayStep5.value,
                  alt: "Your Betslip"
                }, null, 8, _hoisted_31))
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('howToPlay.step5Title')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step5Text1')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step5Text2')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step5Text3')), 1),
            (showBookABetNote.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(_ctx.$t('howToPlay.step5BookBetNote')), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('howToPlay.step6Title')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step6Text1')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step6Text2')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step6Text3')), 1)
          ]),
          _createElementVNode("div", _hoisted_37, [
            (_unref(isLite))
              ? (_openBlock(), _createElementBlock("div", _hoisted_38))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: howToPlayStep6.value,
                  alt: "Wager Details"
                }, null, 8, _hoisted_39))
          ])
        ])
      ])
    ])
  ]))
}
}

})